import axios from "axios";
import config from "../config";

let sites = new Object({
  disableSite(item) {
    return new Promise((resolve, reject) => {
      axios({
        url: item.disabled ? (config.apiEndPoint + "/sites/enable") : (config.apiEndPoint + "/sites/disable"),
        method: "POST",
        data: { id: item.id },
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchSites (ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/fetch",
        method: "POST",
        data : {ctx : ctx}
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchInvoiceData(id) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/fetchInvoice",
        method: "POST",
        data: { id: id },
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchSitesForAccount () {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/fetchSitesForAccount",
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  publish (data) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/publish",
        method: "POST",
        data : data
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  sendPrivacy(data) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/sendPrivacy",
        method: "POST",
        data : data
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },


  deleteSite(id) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/delete",
        method: "POST",
        data: { id: id },
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  startNewWizard() {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/new",
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getDomainMigrationCode() {
    return new Promise((resolve, reject) => {
      axios({
        url: config.apiEndPoint + "/sites/migration",
        method: "POST"
      })
        .then(resp => {
          resolve(resp.data.responseData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

});

export default sites;
